import Litepicker from "../../utils/forms/Litepicker"

class Datepicker {

  constructor (options) {
    this.options = options;
    this.initDatePicker = this.initDatePicker.bind(this);
    this.datePickers = {};

    this.initDatePicker();
  }


  initDatePicker() {
    document.querySelectorAll('.datepicker').forEach((el) => {
      let singleMode = !(el.classList.contains('daterangepicker')),
        inlineMode = (el.classList.contains('inlinepicker'));

      let calendarOptions = {
        element: el,
        lang: Globals.langcode,
        inlineMode: inlineMode,
        singleMode: singleMode,
        format: 'YYYY/MM/DD',
        numberOfMonths: 1,
        numberOfColumns: 1,
        tooltipText: {
          one: Drupal.t('calendar-day'),
          other: Drupal.t('calendar-days')
        }
      };

      if(typeof(el.dataset.endElement) !== 'undefined'){
        calendarOptions.elementEnd = document.getElementById(el.dataset.endElement);
      }

      // Init start/end dates
      if(typeof(el.dataset.start) !== 'undefined'){
        calendarOptions.startDate = el.dataset.start;
      }

      if(typeof(el.dataset.end) !== 'undefined'){
        calendarOptions.endDate = el.dataset.end;
      }

      let picker = new Litepicker(calendarOptions);

      if(el.closest('.sub-filters')){
        this.datePickers[el.closest('.sub-filters').getAttribute('id')] = picker;
      }
    });

    // Date filters
    if (document.querySelectorAll('.sub-filters[data-vid=date]').length !== 0) {
      this.initDateFilters();
    }
  }


  /**
   * Generate date filters
   */
  initDateFilters() {
    document.querySelectorAll('.sub-filters[data-type=dates]').forEach((el) => {
      let id = el.getAttribute('id'),
          picker = this.datePickers[id];

      if (typeof (picker) !== "undefined") {


        picker.setOptions({
          onSelect: function(date1, date2) {
            let filterContainer = document.querySelector('.filters-container');
            let dateField = el.querySelector('input.datepicker');
            let detail = { customTarget: dateField };
            let event = new CustomEvent('change', { detail: detail });
            // Trigger the search
            filterContainer.dispatchEvent(event);
          }
        });

        // el.querySelector('.btn-filter').addEventListener('click', function(ev) {
        //   ev.preventDefault();
        //   let $btn = ev.target;
        //
        //   if ($btn.classList.contains('selected')) {
        //     picker.clearSelection();
        //   }
        //   else {
        //     let dateStart = $btn.dataset.dateStart,
        //         dateEnd = $btn.dataset.dateEnd;
        //
        //     picker.setDateRange(dateStart, dateEnd);
        //     picker.gotoDate(dateStart);
        //
        //     $btn.classList.toggle('selected');
        //   }
        // }); // btn-filter in picker
      } // if picker
    }); // each datepicker
  }; // initDateFilters
}

export default Datepicker;
